import { Injectable } from '@angular/core';

import { linkDownload } from '@cosmos/util-common';
import { fileDownload } from '@cosmos/util-common/file-download';
import { DownloadService } from '@cosmos/util-download/common';

@Injectable()
export class WebDownloadService extends DownloadService {
  async fromImageUrl(props: { url: string; fileName?: string }): Promise<void> {
    if (ngDevMode && !props.fileName) throw new Error('File name is required');
    /**
     * We need to use the linkDownload. Instead of using xhr.
     * Because with XHR we are currently facing CORS issues with.
     * Some images. So inorder to bypass the CORS. We will use linkDownload.
     * And open the images in new Tab.
     */
    linkDownload(props.url, props.fileName);
  }

  async fromBlob(props: { blob: Blob; fileName: string }): Promise<void> {
    fileDownload(props.blob, props.fileName);
  }
}
